const Recharge = () => import('@/views/operat/Recharge')
const Open = () => import('@/views/operat/Open')
const RechargeRecord = () => import('@/views/operat/RechargeRecord')
const OpenRecord = () => import('@/views/operat/openRecord')
export const operat = [
  {
    path: '/partner/recharge',
    name: '充值',
    component: Recharge,
    meta: {
      requireAuth: true,
      title: '充值'
    }
  },
  {
    path: '/partner/product/open',
    name: '商户开通/续费',
    component: Open,
    meta: {
      requireAuth: true,
      title: '商户开通/续费'
    }
  },
  {
    path: '/partner/product/open/record',
    name: '购买记录',
    component: OpenRecord,
    meta: {
      requireAuth: true,
      title: '购买记录'
    }
  },
  {
    path: '/partner/recharge/record',
    name: '充值记录',
    component: RechargeRecord,
    meta: {
      requireAuth: true,
      title: '充值记录'
    }
  },
  // {
  //   path: '/partner/product/open/record',
  //   name: '开通记录',
  //   component: OpenRecord,
  //   meta: {
  //     requireAuth: true,
  //     title: '开通记录'
  //   }
  // },
];



// WEBPACK FOOTER //
// ./src/router/operat.route.js